import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { Icon } from "@iconify/react";
import ReactApexChart from "react-apexcharts";
import { useAppServices } from "../../../hook/services";

/* ── mock data (replace with API response) ───────────────── */
const MOCK = {
  totalRevenue: 15442,  revChange: 12.4,
  totalCost: 688,       costChange: 5.2,
  totalMargin: 14754,   marginChange: 13.1,
  marginPct: 95.5,      marginPctChange: 0.8,
  totalUsers: 10,
  totalLocations: 2,
  activeSaasLocations: 0,
  nonActiveSaasLocations: 2,
  highestAccounts: [
    { name: "AI Elevates", amount: 999, trend: "up" },
    { name: "Digital Vibe Marketing", amount: 999, trend: "up" },
    { name: null, amount: 750, trend: "up" },
    { name: null, amount: 620, trend: "down" },
    { name: "ProCounsel Network", amount: 300, trend: "up" },
  ],
  lowAccounts: [
    { name: null, amount: 0, trend: "down" },
    { name: null, amount: 0, trend: "down" },
    { name: null, amount: 0, trend: "down" },
    { name: null, amount: 0, trend: "down" },
    { name: "Discover Detroit", amount: 0, trend: "down" },
  ],
  chart: {
    categories: ["Apr 1","Apr 3","Apr 5","Apr 7","Apr 9","Apr 11","Apr 13","Apr 15","Apr 17","Apr 19","Apr 21","Apr 23","Apr 25","Apr 27","Apr 29","May 1"],
    revenue:  [200,180,220,3800,400,300,250,320,410,280,350,290,400,310,420,380],
    cost:     [20, 18, 22, 80,  40, 30, 25, 32, 41, 28, 35, 29, 40, 31, 42, 38],
    margin:   [180,162,198,3720,360,270,225,288,369,252,315,261,360,279,378,342],
  },
  plans: [
    {
      name: "SmartDirectoryAI Single Site", accounts: 84, revenue: 12000, cost: 200,
      sub: [
        { label: "Monthly", accounts: 80, revenue: 7900, cost: 120 },
        { label: "Annual",  accounts: 4,  revenue: 4100, cost: 80  },
      ],
    },
    {
      name: "SmartDirectoryAI Unlimited", accounts: 7, revenue: 2100, cost: 100,
      sub: [
        { label: "Monthly", accounts: 5, revenue: 1400, cost: 70 },
        { label: "Annual",  accounts: 2, revenue: 700,  cost: 30 },
      ],
    },
    {
      name: "SmartDirectoryAI - Single - Trial 30", accounts: 23, revenue: 502, cost: 80,
      sub: [
        { label: "Monthly", accounts: 23, revenue: 502, cost: 80 },
      ],
    },
    {
      name: "SmartDirectoryAI - Single - Trial 7", accounts: 10, revenue: 496, cost: 60,
      sub: [
        { label: "Monthly", accounts: 10, revenue: 496, cost: 60 },
      ],
    },
    {
      name: "No Plan", accounts: 20, revenue: 422, cost: 422,
      sub: [],
    },
  ],
  products: [
    { name: "SaaS Subscriptions",       revenue: 8900, cost: 200,  color: "#3b82f6" },
    { name: "Add-ons (Subscriptions)",  revenue: 0.01, cost: 0.01, color: "#f59e0b" },
    { name: "Usage Re-billing (Wallet)",revenue: 6600, cost: 300,  color: "#22c55e" },
  ],
  lostRevenue: {
    totalLost: 3240,
    churnedAccounts: 8,
    cancelledMrr: 2100,
    avgMrrLost: 405,
    cancellationRate: 34,
    items: [
      { name: "BlueSky Agency",      initials: "B", color: "#6366f1", plan: "SmartDirectoryAI Unlimited",    churnedDate: "Apr 28, 2026", mrrLost: 299,   reason: "Price",         status: "Cancelled" },
      { name: "NexGen Solutions",    initials: "N", color: "#ef4444", plan: "SmartDirectoryAI Single Site",  churnedDate: "Apr 21, 2026", mrrLost: 99,    reason: "No Engagement", status: "Cancelled" },
      { name: "Pinnacle Media",      initials: "P", color: "#f59e0b", plan: "SmartDirectoryAI Unlimited",    churnedDate: "Apr 19, 2026", mrrLost: 299,   reason: "Competitor",    status: "Cancelled" },
      { name: "CloudFirst Tech",     initials: "C", color: "#0ea5e9", plan: "SmartDirectoryAI Single Site",  churnedDate: "Apr 15, 2026", mrrLost: 99,    reason: "Failed Payment",status: "Suspended" },
      { name: "Urban Digital Co.",   initials: "U", color: "#8b5cf6", plan: "SmartDirectoryAI Single Site",  churnedDate: "Apr 10, 2026", mrrLost: 99,    reason: "No Engagement", status: "Cancelled" },
      { name: "GreenLeaf Marketing", initials: "G", color: "#22c55e", plan: "SmartDirectoryAI Unlimited",    churnedDate: "Apr 8, 2026",  mrrLost: 299,   reason: "Price",         status: "Cancelled" },
      { name: "Momentum Labs",       initials: "M", color: "#f97316", plan: "SmartDirectoryAI Single Site",  churnedDate: "Apr 3, 2026",  mrrLost: 99,    reason: "Competitor",    status: "Cancelled" },
      { name: "Vertex Creatives",    initials: "V", color: "#06b6d4", plan: "SmartDirectoryAI Single Site",  churnedDate: "Apr 1, 2026",  mrrLost: 2047,  reason: "Price",         status: "Downgraded" },
    ],
  },
  subStats: {
    growing: { count: 1, mom: 267 },
    upgrades: { count: 0 },
    renewals: { count: 1 },
    nonSaas: { count: 9 },
    declining: { count: 3, mom: -74 },
    downgrades: { count: 0 },
    failedPayments: { count: 0 },
    lowWallet: { count: 124 },
  },
  subaccounts: [
    { name: "AI Elevates",          initials: "A",  color: "#3b82f6", owner: "Mike Colligon",    ownerInitials: "MC", signedUp: "Apr 9, 2026",  plan: "SmartDirectoryAI Single Site",   rev: 999,   cost: 0,    margin: 999,   marginPct: 100, renewal: "Apr 9, 2027",  tags: [] },
    { name: "Digital Vibe Marketing",initials: "D", color: "#8b5cf6", owner: "Charles Harrington",ownerInitials: "CH", signedUp: "Apr 22, 2026", plan: "SmartDirectoryAI Single Site",   rev: 999,   cost: 0,    margin: 999,   marginPct: 100, renewal: "Apr 22, 2027", tags: ["Low Wallet"] },
    { name: "ProCounsel Network",   initials: "P",  color: "#06b6d4", owner: "Miriam Vincent",   ownerInitials: "MV", signedUp: "Apr 9, 2026",  plan: "SmartDirectoryAI Unlimited",     rev: 299.52,cost: 0.5,  margin: 299.02,marginPct: 100, renewal: "May 9, 2026",  tags: [] },
    { name: "GHL Foundry CRM",      initials: "G",  color: "#f59e0b", owner: "Lee Kara",         ownerInitials: "LK", signedUp: "Apr 15, 2026", plan: "SmartDirectoryAI Unlimited",     rev: 299,   cost: 0,    margin: 299,   marginPct: 100, renewal: "May 15, 2026", tags: ["Low Wallet"] },
    { name: "GROUP LIFETIME LIMITED",initials: "G", color: "#10b981", owner: "Radu Abiculesei",  ownerInitials: "RA", signedUp: "Apr 19, 2026", plan: "SmartDirectoryAI Unlimited",     rev: 299,   cost: 0,    margin: 299,   marginPct: 100, renewal: "May 19, 2026", tags: ["Low Wallet"] },
    { name: "RoyerAI",              initials: "R",  color: "#ef4444", owner: "Mark Royer",       ownerInitials: "MR", signedUp: "Apr 14, 2026", plan: "SmartDirectoryAI Single Site",   rev: 99.59, cost: 1.39, margin: 98.19, marginPct: 99,  renewal: "May 14, 2026", tags: [] },
    { name: "Brighton Thrive",      initials: "B",  color: "#6366f1", owner: "Dan Lesser",       ownerInitials: "DL", signedUp: "Apr 19, 2026", plan: "SmartDirectoryAI Single Site",   rev: 99.38, cost: 0.41, margin: 98.98, marginPct: 100, renewal: "May 19, 2026", tags: [] },
    { name: "AI Global Revolution", initials: "A",  color: "#0ea5e9", owner: "Ivan Cabrera",     ownerInitials: "IC", signedUp: "Apr 9, 2026",  plan: "SmartDirectoryAI Single Site",   rev: 99.22, cost: 1.05, margin: 98.17, marginPct: 99,  renewal: "May 9, 2026",  tags: [] },
    { name: "Denton Thrive",        initials: "D",  color: "#f97316", owner: "Kurt Stockhausen", ownerInitials: "KS", signedUp: "Apr 9, 2026",  plan: "SmartDirectoryAI Single Site",   rev: 99.21, cost: 1.04, margin: 98.17, marginPct: 99,  renewal: "May 9, 2026",  tags: [] },
    { name: "Mainely Travel Info",  initials: "M",  color: "#84cc16", owner: "Clint Griffin",    ownerInitials: "CG", signedUp: "Apr 19, 2026", plan: "SmartDirectoryAI Single Site",   rev: 99.09, cost: 0.09, margin: 99,    marginPct: 100, renewal: "May 19, 2026", tags: [] },
  ],
  totalSubaccounts: 154,
};

/* ── helpers ─────────────────────────────────────────────── */
const fmt = (n) =>
  n >= 1000 ? `$${(n / 1000).toFixed(1)}k` : `$${Number(n).toLocaleString()}`;

function RevenueBar({ revenue, cost, maxRevenue }) {
  const pct = Math.min((revenue / maxRevenue) * 100, 100);
  const costPct = revenue > 0 ? Math.min((cost / revenue) * 100, 100) : 100;
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 8, minWidth: 0 }}>
      <div style={{ flex: 1, height: 18, borderRadius: 4, overflow: "hidden", background: "#f3f4f6", maxWidth: 200 }}>
        <div style={{ width: `${pct}%`, height: "100%", display: "flex" }}>
          <div style={{ width: `${costPct}%`, background: "#ef4444", height: "100%" }} />
          <div style={{ flex: 1, background: "#22c55e", height: "100%" }} />
        </div>
      </div>
      <span style={{ fontSize: 13, fontWeight: 600, whiteSpace: "nowrap", minWidth: 52, textAlign: "right" }}>
        {fmt(revenue)}
      </span>
    </div>
  );
}

/* ── main component ──────────────────────────────────────── */
const RevenueAnalytics = () => {
  const { companyId } = useParams();
  const AppService = useAppServices();
  const [data, setData] = useState(MOCK);
  const [loading, setLoading] = useState(false);
  const [activeTab, setActiveTab] = useState("overview");
  const [chartRange, setChartRange] = useState("Daily");
  const [planFilter, setPlanFilter] = useState("All Plans");
  const [dateFilter, setDateFilter] = useState("Last 30 days");
  const [expandedPlans, setExpandedPlans] = useState({});
  const [subSearch, setSubSearch] = useState("");
  const [subPage, setSubPage] = useState(1);
  const SUB_PAGE_SIZE = 10;

  const togglePlan = (i) => setExpandedPlans((prev) => ({ ...prev, [i]: !prev[i] }));

  const filteredSubs = data.subaccounts.filter((s) =>
    s.name.toLowerCase().includes(subSearch.toLowerCase()) ||
    s.owner.toLowerCase().includes(subSearch.toLowerCase())
  );

  const fetchData = async () => {
    setLoading(true);
    try {
      const { response } = await AppService.webhook.getRevenueAnalytics?.({
        query: `company_id=${companyId}`,
      });
      if (response) setData(response);
    } catch {
      /* keep mock */
    } finally {
      setLoading(false);
    }
  };

  const chartOptions = {
    chart: { type: "line", toolbar: { show: false }, zoom: { enabled: false } },
    stroke: { curve: "smooth", width: 2 },
    colors: ["#3b82f6", "#ef4444", "#22c55e"],
    legend: { show: false },
    xaxis: {
      categories: data.chart.categories,
      labels: { style: { fontSize: "11px" } },
      axisBorder: { show: false },
      axisTicks: { show: false },
    },
    yaxis: { labels: { formatter: (v) => (v >= 1000 ? `${v / 1000}k` : v), style: { fontSize: "11px" } } },
    grid: { borderColor: "#f3f4f6", strokeDashArray: 4 },
    tooltip: { y: { formatter: (v) => `$${v.toLocaleString()}` } },
  };

  const chartSeries = [
    { name: "Revenue", data: data.chart.revenue },
    { name: "Cost",    data: data.chart.cost },
    { name: "Margin",  data: data.chart.margin },
  ];

  const maxPlanRevenue = Math.max(...data.plans.map((p) => p.revenue));
  const maxProductRevenue = Math.max(...data.products.map((p) => p.revenue));

  const stats = [
    { label: "Total Revenue", value: `$${data.totalRevenue.toLocaleString()}`, change: data.revChange,       icon: "solar:dollar-minimalistic-outline", bg: "#dcfce7", color: "#16a34a" },
    { label: "Total Cost",    value: `$${data.totalCost.toLocaleString()}`,    change: data.costChange,      icon: "solar:bill-list-outline",             bg: "#fee2e2", color: "#dc2626" },
    { label: "Total Margin",  value: `$${data.totalMargin.toLocaleString()}`,  change: data.marginChange,    icon: "solar:graph-new-up-outline",          bg: "#dcfce7", color: "#16a34a" },
    { label: "Margin %",      value: `${data.marginPct}%`,                     change: data.marginPctChange, icon: "solar:pie-chart-2-outline",           bg: "#eff6ff", color: "#2563eb" },
  ];

  return (
    <div className="container-fluid p-24">

      {/* Header */}
      <div className="d-flex align-items-start justify-content-between flex-wrap gap-12 mb-16">
        <div>
          <h4 className="fw-semibold mb-2" style={{ letterSpacing: "-0.01em" }}>Revenue Analytics</h4>
          <p className="text-secondary-light mb-0 text-sm">Customer Spend &amp; Profit Trends</p>
        </div>
        <div className="d-flex align-items-center gap-10 flex-wrap">
          <div className="position-relative">
            <select
              className="form-select form-select-sm radius-8 pe-32"
              value={planFilter}
              onChange={(e) => setPlanFilter(e.target.value)}
              style={{ minWidth: 130 }}
            >
              <option>All Plans</option>
              {data.plans.map((p, i) => <option key={i}>{p.name}</option>)}
            </select>
          </div>
          <div className="position-relative">
            <select
              className="form-select form-select-sm radius-8 pe-32"
              value={dateFilter}
              onChange={(e) => setDateFilter(e.target.value)}
              style={{ minWidth: 140 }}
            >
              <option>Last 30 days</option>
              <option>Last 7 days</option>
              <option>Last 90 days</option>
              <option>This year</option>
            </select>
          </div>
        </div>
      </div>

      {/* Tabs */}
      <div className="mb-24" style={{ borderBottom: "2px solid var(--border-color)" }}>
        <div className="d-flex gap-0">
          {[
            { key: "overview",     label: "Overview",      icon: "solar:chart-2-outline" },
            { key: "subaccounts",  label: "Subaccounts",   icon: "solar:users-group-rounded-outline" },
            { key: "lostRevenue",  label: "Lost Revenue",  icon: "solar:graph-down-outline" },
          ].map((tab) => (
            <button
              key={tab.key}
              onClick={() => setActiveTab(tab.key)}
              style={{
                padding: "10px 20px",
                background: "none",
                border: "none",
                borderBottom: activeTab === tab.key ? "2px solid var(--primary-600)" : "2px solid transparent",
                marginBottom: -2,
                color: activeTab === tab.key ? "var(--primary-600)" : "var(--text-secondary-light)",
                fontWeight: activeTab === tab.key ? 600 : 400,
                fontSize: 14,
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                gap: 6,
                transition: "color 0.15s, border-color 0.15s",
              }}
            >
              <Icon icon={tab.icon} style={{ fontSize: 16 }} />
              {tab.label}
            </button>
          ))}
        </div>
      </div>

      {/* Subaccounts Tab */}
      {activeTab === "subaccounts" && (() => {
        const ss = data.subStats;
        const statCards = [
          [
            { label: "Growing Accounts",        sub: "Spend up >10%. Ready for upsell.", value: ss.growing.count,        mom: ss.growing.mom,  icon: "solar:graph-new-up-outline",        bg: "#f0fdf4", iconColor: "#16a34a" },
            { label: "Plan Upgrades",            sub: "Recent expansions.",               value: ss.upgrades.count,       mom: null,            icon: "solar:upload-minimalistic-outline", bg: "#f0fdf4", iconColor: "#16a34a" },
            { label: "Upcoming Annual Renewals", sub: "Track now to prevent churn.",      value: ss.renewals.count,       mom: null,            icon: "solar:calendar-outline",            bg: "#eff6ff", iconColor: "#2563eb" },
            { label: "Non-SaaS Accounts",        sub: "Target for SaaS upsell.",          value: ss.nonSaas.count,        mom: null,            icon: "solar:buildings-2-outline",         bg: "#eff6ff", iconColor: "#2563eb" },
          ],
          [
            { label: "Declining Accounts",  sub: "Spend down >10%. At risk.",      value: ss.declining.count,      mom: ss.declining.mom, icon: "solar:graph-down-outline",           bg: "#fef2f2", iconColor: "#dc2626" },
            { label: "Plan Downgrades",     sub: "Recent contractions.",            value: ss.downgrades.count,     mom: null,             icon: "solar:download-minimalistic-outline",bg: "#fef2f2", iconColor: "#dc2626" },
            { label: "Failed Payments",     sub: "Needs immediate follow-up.",      value: ss.failedPayments.count, mom: null,             icon: "solar:close-circle-outline",         bg: "#fef2f2", iconColor: "#dc2626" },
            { label: "Low Wallet Balance",  sub: "Services paused. Needs top-up.", value: ss.lowWallet.count,       mom: null,             icon: "solar:wallet-outline",               bg: "#fff7ed", iconColor: "#ea580c" },
          ],
        ];
        return (
          <>
            {/* Stat card rows */}
            {statCards.map((row, ri) => (
              <div className="row gy-3 mb-16" key={ri}>
                {row.map((s, ci) => (
                  <div className="col-xl-3 col-sm-6" key={ci}>
                    <div className="card h-100" style={{ border: "1px solid var(--border-color)" }}>
                      <div className="card-body p-16 d-flex align-items-start justify-content-between gap-8">
                        <div>
                          <p className="fw-semibold text-sm mb-2 d-flex align-items-center gap-6">
                            {s.label}
                            <Icon icon="solar:info-circle-outline" style={{ fontSize: 13, opacity: 0.5 }} />
                          </p>
                          <p className="text-secondary-light mb-10" style={{ fontSize: 11 }}>{s.sub}</p>
                          <div className="d-flex align-items-center gap-8">
                            <span className="fw-bold" style={{ fontSize: 26 }}>{s.value}</span>
                            {s.mom != null && (
                              <span style={{ fontSize: 11, fontWeight: 600, color: s.mom > 0 ? "#16a34a" : "#dc2626" }}>
                                {s.mom > 0 ? "↑" : "↓"} {Math.abs(s.mom)}% MoM
                              </span>
                            )}
                          </div>
                        </div>
                        <div className="d-flex align-items-center justify-content-center rounded-circle flex-shrink-0"
                          style={{ width: 40, height: 40, background: s.bg }}>
                          <Icon icon={s.icon} style={{ fontSize: 18, color: s.iconColor }} />
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            ))}

            {/* Toolbar */}
            <div className="d-flex align-items-center gap-12 mb-16 flex-wrap">
              <span className="px-12 py-6 radius-8 text-sm fw-semibold"
                style={{ background: "#f3f4f6", whiteSpace: "nowrap" }}>
                {data.totalSubaccounts} sub-accounts
              </span>
              <div className="flex-grow-1 position-relative" style={{ maxWidth: 420 }}>
                <Icon icon="solar:magnifer-outline" style={{ position: "absolute", left: 12, top: "50%", transform: "translateY(-50%)", fontSize: 16, color: "#9ca3af" }} />
                <input
                  className="form-control form-control-sm radius-8"
                  style={{ paddingLeft: 36 }}
                  placeholder="Search by name, email, or owner..."
                  value={subSearch}
                  onChange={(e) => { setSubSearch(e.target.value); setSubPage(1); }}
                />
              </div>
              <button className="btn btn-sm d-flex align-items-center gap-6 radius-8 px-14 py-6"
                style={{ border: "1px solid var(--border-color)", background: "#fff", fontSize: 13 }}>
                <Icon icon="solar:tuning-2-outline" style={{ fontSize: 15 }} /> Columns
              </button>
              <button className="btn btn-sm d-flex align-items-center gap-6 radius-8 px-14 py-6"
                style={{ border: "1px solid var(--border-color)", background: "#fff", fontSize: 13 }}>
                <Icon icon="solar:filter-outline" style={{ fontSize: 15 }} /> Filter
              </button>
            </div>

            {/* Table */}
            <div className="card" style={{ overflow: "hidden" }}>
              <div style={{ overflowX: "auto" }}>
                <table style={{ width: "100%", borderCollapse: "collapse", minWidth: 900 }}>
                  <thead>
                    <tr style={{ background: "#fafafa", borderBottom: "1px solid var(--border-color)" }}>
                      <th style={{ width: 36, padding: "10px 16px" }}>
                        <input type="checkbox" style={{ accentColor: "var(--primary-600)" }} />
                      </th>
                      {[
                        { label: "Account", sort: true },
                        { label: "Owner", sort: true },
                        { label: "Signed-up", sort: true },
                        { label: "Plan", sort: true, info: true },
                        { label: "Total Rev", sort: true, info: true },
                        { label: "Total Cost", sort: false, info: true },
                        { label: "Total Margin", sort: false, info: true },
                        { label: "Margin %", sort: false, info: true },
                        { label: "Renewal", sort: true, filter: true },
                        { label: "Tags", sort: false, info: true, filter: true },
                      ].map((col, ci) => (
                        <th key={ci} style={{ padding: "10px 12px", fontSize: 11, fontWeight: 600, color: "#6b7280", textTransform: "uppercase", letterSpacing: "0.04em", whiteSpace: "nowrap", textAlign: ci >= 4 && ci <= 7 ? "right" : "left" }}>
                          <span className="d-inline-flex align-items-center gap-4">
                            {col.label}
                            {col.info && <Icon icon="solar:info-circle-outline" style={{ fontSize: 12, opacity: 0.5 }} />}
                            {col.sort && <Icon icon="solar:sort-vertical-outline" style={{ fontSize: 11, opacity: 0.4 }} />}
                            {col.filter && <Icon icon="solar:filter-outline" style={{ fontSize: 11, opacity: 0.4 }} />}
                          </span>
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {filteredSubs.map((acc, i) => (
                      <tr key={i} style={{ borderBottom: "1px solid var(--border-color)", transition: "background 0.12s" }}
                        onMouseEnter={(e) => e.currentTarget.style.background = "#fafbff"}
                        onMouseLeave={(e) => e.currentTarget.style.background = "transparent"}>
                        <td style={{ padding: "12px 16px" }}>
                          <input type="checkbox" style={{ accentColor: "var(--primary-600)" }} />
                        </td>
                        {/* Account */}
                        <td style={{ padding: "12px 12px", minWidth: 140 }}>
                          <div className="d-flex align-items-center gap-10">
                            <div className="d-flex align-items-center justify-content-center rounded-circle fw-bold flex-shrink-0"
                              style={{ width: 32, height: 32, background: acc.color + "22", color: acc.color, fontSize: 13 }}>
                              {acc.initials}
                            </div>
                            <span style={{ color: "var(--primary-600)", fontWeight: 500, fontSize: 13, cursor: "pointer" }}>{acc.name}</span>
                          </div>
                        </td>
                        {/* Owner */}
                        <td style={{ padding: "12px 12px", minWidth: 130 }}>
                          <div className="d-flex align-items-center gap-8">
                            <div className="d-flex align-items-center justify-content-center rounded-circle fw-semibold flex-shrink-0"
                              style={{ width: 26, height: 26, background: "#e5e7eb", color: "#374151", fontSize: 11 }}>
                              {acc.ownerInitials}
                            </div>
                            <span style={{ fontSize: 13, color: "#374151" }}>{acc.owner}</span>
                          </div>
                        </td>
                        {/* Signed-up */}
                        <td style={{ padding: "12px 12px", fontSize: 13, color: "#6b7280", whiteSpace: "nowrap" }}>{acc.signedUp}</td>
                        {/* Plan */}
                        <td style={{ padding: "12px 12px", fontSize: 13, maxWidth: 160 }}>{acc.plan}</td>
                        {/* Rev */}
                        <td style={{ padding: "12px 12px", textAlign: "right" }}>
                          <span style={{ fontSize: 13, fontWeight: 600 }}>${acc.rev.toFixed(2)}</span>
                          <div style={{ fontSize: 11, color: "#9ca3af" }}>—0.0%</div>
                        </td>
                        {/* Cost */}
                        <td style={{ padding: "12px 12px", textAlign: "right" }}>
                          <span style={{ fontSize: 13, fontWeight: 600, color: acc.cost > 0 ? "#ef4444" : "#6b7280" }}>${acc.cost.toFixed(2)}</span>
                          <div style={{ fontSize: 11, color: "#9ca3af" }}>—0.0%</div>
                        </td>
                        {/* Margin */}
                        <td style={{ padding: "12px 12px", textAlign: "right" }}>
                          <span style={{ fontSize: 13, fontWeight: 600, color: "#16a34a" }}>${acc.margin.toFixed(2)}</span>
                          <div style={{ fontSize: 11, color: "#9ca3af" }}>—0.0%</div>
                        </td>
                        {/* Margin % */}
                        <td style={{ padding: "12px 12px", textAlign: "right" }}>
                          <span style={{ fontSize: 13, fontWeight: 600, color: "#16a34a" }}>{acc.marginPct}%</span>
                        </td>
                        {/* Renewal */}
                        <td style={{ padding: "12px 12px", fontSize: 13, color: "#6b7280", whiteSpace: "nowrap" }}>{acc.renewal}</td>
                        {/* Tags */}
                        <td style={{ padding: "12px 12px" }}>
                          {acc.tags.map((tag, ti) => (
                            <span key={ti} style={{ fontSize: 11, fontWeight: 600, padding: "3px 8px", borderRadius: 6, background: "#fef9c3", color: "#92400e", border: "1px solid #fde68a", whiteSpace: "nowrap" }}>
                              {tag}
                            </span>
                          ))}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              {/* Pagination */}
              <div className="d-flex align-items-center justify-content-between px-16 py-12" style={{ borderTop: "1px solid var(--border-color)" }}>
                <div className="d-flex align-items-center gap-8">
                  <span style={{ fontSize: 13, color: "#6b7280" }}>Showing</span>
                  <select className="form-select form-select-sm radius-6" style={{ width: 64, fontSize: 13 }}
                    defaultValue={10}>
                    <option>10</option><option>25</option><option>50</option>
                  </select>
                  <span style={{ fontSize: 13, color: "#6b7280" }}>of {data.totalSubaccounts} results</span>
                </div>
                <div className="d-flex align-items-center gap-8">
                  <button className="btn btn-sm radius-6 px-10 py-4" style={{ border: "1px solid var(--border-color)", fontSize: 13 }}
                    disabled={subPage === 1} onClick={() => setSubPage(p => Math.max(1, p - 1))}>
                    <Icon icon="solar:alt-arrow-left-outline" /> Previous
                  </button>
                  <span className="d-flex align-items-center justify-content-center radius-6 fw-semibold"
                    style={{ width: 32, height: 32, background: "var(--primary-600)", color: "#fff", fontSize: 13 }}>
                    {subPage}
                  </span>
                  <span style={{ fontSize: 13, color: "#6b7280" }}>/ {Math.ceil(data.totalSubaccounts / SUB_PAGE_SIZE)}</span>
                  <button className="btn btn-sm radius-6 px-10 py-4" style={{ border: "1px solid var(--border-color)", fontSize: 13 }}
                    onClick={() => setSubPage(p => p + 1)}>
                    Next <Icon icon="solar:alt-arrow-right-outline" />
                  </button>
                </div>
              </div>
            </div>
          </>
        );
      })()}

      {/* Overview Tab */}
      {activeTab === "overview" && <>

      {/* Stat Cards — row 1 */}
      <div className="row gy-4 mb-16">
        {stats.map((s, i) => (
          <div className="col-xxl-3 col-xl-3 col-sm-6" key={i}>
            <div className="card h-100">
              <div className="card-body p-20 d-flex align-items-center justify-content-between gap-12">
                <div>
                  <p className="text-secondary-light text-sm mb-6 d-flex align-items-center gap-6">
                    {s.label}
                    <Icon icon="solar:info-circle-outline" className="text-secondary-light" style={{ fontSize: 14 }} />
                  </p>
                  <h4 className="fw-bold mb-4">{s.value}</h4>
                  {s.change != null && (
                    <span style={{
                      display: "inline-flex", alignItems: "center", gap: 3,
                      fontSize: 12, fontWeight: 600,
                      color: s.change >= 0 ? "#16a34a" : "#dc2626",
                    }}>
                      <Icon
                        icon={s.change >= 0 ? "solar:arrow-right-up-bold" : "solar:arrow-right-down-bold"}
                        style={{ fontSize: 13 }}
                      />
                      {s.change >= 0 ? "+" : ""}{s.change}% vs prev
                    </span>
                  )}
                </div>
                <div
                  className="d-flex align-items-center justify-content-center rounded-circle flex-shrink-0"
                  style={{ width: 48, height: 48, background: s.bg }}
                >
                  <Icon icon={s.icon} style={{ fontSize: 22, color: s.color }} />
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Stat Cards — row 2 */}
      <div className="row gy-4 mb-24">
        {[
          { label: "Total Users",              value: data.totalUsers,              icon: "solar:user-outline",              bg: "#eff6ff", color: "#2563eb" },
          { label: "Total Locations",          value: data.totalLocations,          icon: "solar:buildings-2-outline",       bg: "#f5f3ff", color: "#7c3aed" },
          { label: "Active Saas Locations",    value: data.activeSaasLocations,     icon: "solar:check-circle-outline",      bg: "#f0fdf4", color: "#16a34a" },
          { label: "Non-Active Saas Locations",value: data.nonActiveSaasLocations,  icon: "solar:close-circle-outline",      bg: "#fef2f2", color: "#dc2626" },
        ].map((s, i) => (
          <div className="col-xxl-3 col-xl-3 col-sm-6" key={i}>
            <div className="card h-100">
              <div className="card-body p-20 d-flex align-items-center justify-content-between gap-12">
                <div>
                  <p className="text-secondary-light text-sm mb-6">{s.label}</p>
                  <h4 className="fw-bold mb-0">{s.value}</h4>
                </div>
                <div className="d-flex align-items-center justify-content-center rounded-circle flex-shrink-0"
                  style={{ width: 48, height: 48, background: s.bg }}>
                  <Icon icon={s.icon} style={{ fontSize: 22, color: s.color }} />
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Accounts Tables */}
      <div className="row gy-4 mb-24">
        {/* Highest Paying */}
        <div className="col-xl-6">
          <div className="card h-100">
            <div className="card-header border-bottom bg-base py-16 px-24 d-flex align-items-center gap-8">
              <Icon icon="solar:dollar-minimalistic-outline" className="text-secondary-light" />
              <h6 className="fw-semibold mb-0 text-sm">Highest Paying Accounts</h6>
              <Icon icon="solar:info-circle-outline" className="text-secondary-light ms-auto" style={{ fontSize: 14 }} />
            </div>
            <div className="card-body p-0">
              {data.highestAccounts.map((acc, i) => (
                <div
                  key={i}
                  className="d-flex align-items-center justify-content-between px-24 py-12"
                  style={{ borderBottom: i < data.highestAccounts.length - 1 ? "1px solid var(--border-color)" : "none" }}
                >
                  <div className="d-flex align-items-center gap-12">
                    <span className="text-secondary-light text-sm fw-medium" style={{ minWidth: 16 }}>{i + 1}</span>
                    {acc.name ? (
                      <span className="fw-medium text-sm">{acc.name}</span>
                    ) : (
                      <div style={{ width: 140, height: 14, borderRadius: 4, background: "#e5e7eb", filter: "blur(4px)" }} />
                    )}
                  </div>
                  <div className="d-flex align-items-center gap-8">
                    {acc.name ? (
                      <>
                        <span className="fw-semibold text-sm">${acc.amount}</span>
                        <Icon
                          icon={acc.trend === "up" ? "solar:alt-arrow-up-bold" : "solar:alt-arrow-down-bold"}
                          style={{ color: acc.trend === "up" ? "#16a34a" : "#dc2626", fontSize: 14 }}
                        />
                      </>
                    ) : (
                      <button className="btn btn-sm px-12 py-4 radius-6 d-flex align-items-center gap-6"
                        style={{ background: "#fef9c3", color: "#92400e", border: "1px solid #fde68a", fontSize: 12 }}>
                        <Icon icon="solar:lock-outline" style={{ fontSize: 12 }} />
                        Unlock
                      </button>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Low Spending */}
        <div className="col-xl-6">
          <div className="card h-100">
            <div className="card-header border-bottom bg-base py-16 px-24 d-flex align-items-center gap-8">
              <Icon icon="solar:dollar-minimalistic-outline" className="text-secondary-light" />
              <h6 className="fw-semibold mb-0 text-sm">Low Spending Accounts</h6>
              <Icon icon="solar:info-circle-outline" className="text-secondary-light ms-auto" style={{ fontSize: 14 }} />
            </div>
            <div className="card-body p-0">
              {data.lowAccounts.map((acc, i) => (
                <div
                  key={i}
                  className="d-flex align-items-center justify-content-between px-24 py-12"
                  style={{ borderBottom: i < data.lowAccounts.length - 1 ? "1px solid var(--border-color)" : "none" }}
                >
                  <div className="d-flex align-items-center gap-12">
                    <span className="text-secondary-light text-sm fw-medium" style={{ minWidth: 16 }}>{i + 1}</span>
                    {acc.name ? (
                      <span className="fw-medium text-sm">{acc.name}</span>
                    ) : (
                      <div style={{ width: 160, height: 14, borderRadius: 4, background: "#e5e7eb", filter: "blur(4px)" }} />
                    )}
                  </div>
                  <div className="d-flex align-items-center gap-8">
                    {acc.name ? (
                      <>
                        <span className="fw-semibold text-sm">${acc.amount}</span>
                        <Icon
                          icon={acc.trend === "up" ? "solar:alt-arrow-up-bold" : "solar:alt-arrow-down-bold"}
                          style={{ color: acc.trend === "up" ? "#16a34a" : "#dc2626", fontSize: 14 }}
                        />
                      </>
                    ) : (
                      <button className="btn btn-sm px-12 py-4 radius-6 d-flex align-items-center gap-6"
                        style={{ background: "#fef9c3", color: "#92400e", border: "1px solid #fde68a", fontSize: 12 }}>
                        <Icon icon="solar:lock-outline" style={{ fontSize: 12 }} />
                        Unlock
                      </button>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Financial Overview Chart */}
      <div className="card mb-24">
        <div className="card-header border-bottom bg-base py-16 px-24 d-flex align-items-center justify-content-between">
          <div>
            <div className="d-flex align-items-center gap-8 mb-4">
              <h6 className="fw-semibold mb-0">Financial Overview</h6>
              <Icon icon="solar:info-circle-outline" className="text-secondary-light" style={{ fontSize: 14 }} />
            </div>
            <p className="text-secondary-light text-xs mb-0">Cost, Revenue &amp; Margin over time</p>
          </div>
          <div className="d-flex align-items-center gap-16">
            <div className="d-flex align-items-center gap-16">
              {[{ label: "Revenue", color: "#3b82f6" }, { label: "Cost", color: "#ef4444" }, { label: "Margin", color: "#22c55e" }].map((l) => (
                <span key={l.label} className="d-flex align-items-center gap-6 text-xs text-secondary-light">
                  <span style={{ width: 24, height: 2, background: l.color, display: "inline-block", borderRadius: 2 }} />
                  {l.label}
                </span>
              ))}
            </div>
            <select
              className="form-select form-select-sm radius-8"
              value={chartRange}
              onChange={(e) => setChartRange(e.target.value)}
              style={{ width: 90 }}
            >
              <option>Daily</option>
              <option>Weekly</option>
              <option>Monthly</option>
            </select>
          </div>
        </div>
        <div className="card-body p-16">
          <ReactApexChart options={chartOptions} series={chartSeries} type="line" height={280} />
        </div>
      </div>

      {/* Revenue by SaaS Plan */}
      <div className="card mb-24">
        <div className="card-header border-bottom bg-base py-16 px-24">
          <div className="d-flex align-items-center gap-8 mb-4">
            <h6 className="fw-semibold mb-0">Revenue by SaaS Plan</h6>
            <Icon icon="solar:info-circle-outline" className="text-secondary-light" style={{ fontSize: 14 }} />
          </div>
          <p className="text-secondary-light text-xs mb-8">See which plans generate the most revenue &amp; margins</p>
          <div className="d-flex align-items-center gap-16">
            {[{ label: "Cost (COGS)", color: "#ef4444" }, { label: "Gross Profit (Margin)", color: "#22c55e" }].map((l) => (
              <span key={l.label} className="d-flex align-items-center gap-6 text-xs text-secondary-light">
                <span style={{ width: 10, height: 10, borderRadius: "50%", background: l.color, display: "inline-block" }} />
                {l.label}
              </span>
            ))}
          </div>
        </div>
        <div className="card-body p-0">
          <div className="px-24 py-10 d-flex align-items-center" style={{ borderBottom: "1px solid var(--border-color)", background: "#fafafa" }}>
            <span className="text-xs fw-semibold text-secondary-light" style={{ flex: 1 }}>Plan</span>
            <span className="text-xs fw-semibold text-secondary-light" style={{ width: 80, textAlign: "right" }}>Accounts</span>
            <span className="text-xs fw-semibold text-secondary-light" style={{ width: 260, textAlign: "right", paddingRight: 8 }}>Revenue &amp; Margin</span>
          </div>
          {data.plans.map((plan, i) => (
            <React.Fragment key={i}>
              {/* Parent row */}
              <div
                className="px-24 py-12 d-flex align-items-center"
                style={{
                  borderBottom: "1px solid var(--border-color)",
                  cursor: plan.sub?.length ? "pointer" : "default",
                  background: expandedPlans[i] ? "var(--primary-50)" : "transparent",
                  transition: "background 0.15s",
                }}
                onClick={() => plan.sub?.length && togglePlan(i)}
              >
                <div className="d-flex align-items-center gap-8" style={{ flex: 1 }}>
                  <Icon
                    icon={expandedPlans[i] ? "solar:alt-arrow-down-outline" : "solar:alt-arrow-right-outline"}
                    className="text-secondary-light"
                    style={{ fontSize: 14, flexShrink: 0, opacity: plan.sub?.length ? 1 : 0 }}
                  />
                  <span className="text-sm fw-medium">{plan.name}</span>
                </div>
                <span className="text-sm text-secondary-light" style={{ width: 80, textAlign: "right" }}>{plan.accounts}</span>
                <div style={{ width: 260 }}>
                  <RevenueBar revenue={plan.revenue} cost={plan.cost} maxRevenue={maxPlanRevenue} />
                </div>
              </div>

              {/* Sub-rows (Monthly / Annual) */}
              {expandedPlans[i] && plan.sub?.map((sub, j) => (
                <div
                  key={j}
                  className="d-flex align-items-center"
                  style={{
                    borderBottom: "1px solid var(--border-color)",
                    background: "#fafbff",
                    paddingLeft: 56,
                    paddingRight: 24,
                    paddingTop: 10,
                    paddingBottom: 10,
                  }}
                >
                  <span className="text-sm text-secondary-light" style={{ flex: 1 }}>{sub.label}</span>
                  <span className="text-sm text-secondary-light" style={{ width: 80, textAlign: "right" }}>{sub.accounts}</span>
                  <div style={{ width: 260 }}>
                    <RevenueBar revenue={sub.revenue} cost={sub.cost} maxRevenue={maxPlanRevenue} />
                  </div>
                </div>
              ))}
            </React.Fragment>
          ))}
          <p className="text-secondary-light text-xs text-center py-10 mb-0" style={{ borderTop: "1px solid var(--border-color)" }}>
            Click on Revenue &amp; Margin bars to filter sub-accounts by plan
          </p>
        </div>
      </div>

      {/* Revenue by Product/Service */}
      <div className="card">
        <div className="card-header border-bottom bg-base py-16 px-24">
          <div className="d-flex align-items-center gap-8 mb-4">
            <h6 className="fw-semibold mb-0">Revenue by Product/Service</h6>
            <Icon icon="solar:info-circle-outline" className="text-secondary-light" style={{ fontSize: 14 }} />
          </div>
          <p className="text-secondary-light text-xs mb-8">Breakdown by offering (with cost &amp; margin for usage-based products)</p>
          <div className="d-flex align-items-center gap-16">
            {[{ label: "Cost (COGS)", color: "#ef4444" }, { label: "Gross Profit (Margin)", color: "#22c55e" }].map((l) => (
              <span key={l.label} className="d-flex align-items-center gap-6 text-xs text-secondary-light">
                <span style={{ width: 10, height: 10, borderRadius: "50%", background: l.color, display: "inline-block" }} />
                {l.label}
              </span>
            ))}
          </div>
        </div>
        <div className="card-body p-0">
          <div className="px-24 py-10 d-flex align-items-center" style={{ borderBottom: "1px solid var(--border-color)", background: "#fafafa" }}>
            <span className="text-xs fw-semibold text-secondary-light" style={{ flex: 1 }}>Product/Service</span>
            <span className="text-xs fw-semibold text-secondary-light" style={{ width: 260, textAlign: "right", paddingRight: 8 }}>Revenue &amp; Margin</span>
          </div>
          {data.products.map((prod, i) => (
            <div
              key={i}
              className="px-24 py-12 d-flex align-items-center"
              style={{ borderBottom: i < data.products.length - 1 ? "1px solid var(--border-color)" : "none", borderLeft: `3px solid ${prod.color}` }}
            >
              <div className="d-flex align-items-center gap-8" style={{ flex: 1 }}>
                <Icon icon="solar:alt-arrow-right-outline" className="text-secondary-light" style={{ fontSize: 14, flexShrink: 0 }} />
                <span className="text-sm">{prod.name}</span>
              </div>
              <div style={{ width: 260 }}>
                <RevenueBar revenue={prod.revenue} cost={prod.cost} maxRevenue={maxProductRevenue} />
              </div>
            </div>
          ))}
          <p className="text-secondary-light text-xs text-center py-10 mb-0" style={{ borderTop: "1px solid var(--border-color)" }}>
            Click on Revenue &amp; Margin bars to filter sub-accounts by product/service
          </p>
        </div>
      </div>

      </> /* end overview tab */}

      {/* Lost Revenue Tab */}
      {activeTab === "lostRevenue" && (
        <>
          {/* KPI cards */}
          <div className="row gy-3 mb-24">
            {[
              { label: "Total Lost Revenue", sub: "Churned + cancelled + downgrades", value: `$${data.lostRevenue.totalLost.toLocaleString()}`,   icon: "solar:graph-down-outline",            bg: "#fef2f2", color: "#dc2626" },
              { label: "Churned Accounts",   sub: "Accounts lost this period",        value: data.lostRevenue.churnedAccounts,                    icon: "solar:user-minus-rounded-outline",     bg: "#fff7ed", color: "#9a3412" },
              { label: "Cancelled MRR",      sub: "Monthly recurring revenue lost",   value: `$${data.lostRevenue.cancelledMrr.toLocaleString()}`, icon: "solar:close-circle-outline",           bg: "#fef2f2", color: "#dc2626" },
              { label: "Cancellation Rate",  sub: "Accounts cancelled this period",   value: `${data.lostRevenue.cancellationRate}%`,              icon: "solar:close-square-outline",           bg: "#fef2f2", color: "#dc2626" },
            ].map((s, i) => (
              <div className="col-xl-3 col-sm-6" key={i}>
                <div className="card h-100" style={{ border: "1px solid var(--border-color)" }}>
                  <div className="card-body p-20 d-flex align-items-center justify-content-between gap-12">
                    <div>
                      <p className="text-secondary-light text-sm mb-4 d-flex align-items-center gap-6">
                        {s.label}
                        <Icon icon="solar:info-circle-outline" className="text-secondary-light" style={{ fontSize: 13 }} />
                      </p>
                      <p style={{ fontSize: 11, color: "#9ca3af", marginBottom: 8 }}>{s.sub}</p>
                      <h4 className="fw-bold mb-0" style={{ color: s.color }}>{s.value}</h4>
                    </div>
                    <div className="d-flex align-items-center justify-content-center rounded-circle flex-shrink-0"
                      style={{ width: 48, height: 48, background: s.bg }}>
                      <Icon icon={s.icon} style={{ fontSize: 22, color: s.color }} />
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Charts row */}
          <div className="row gy-4 mb-24">

            {/* Chart 1 — Lost Revenue Timeline */}
            <div className="col-xl-8">
              <div className="card h-100">
                <div className="card-header border-bottom bg-base py-16 px-24 d-flex align-items-center justify-content-between">
                  <div>
                    <div className="d-flex align-items-center gap-8 mb-4">
                      <h6 className="fw-semibold mb-0">Lost Revenue Timeline</h6>
                      <Icon icon="solar:info-circle-outline" className="text-secondary-light" style={{ fontSize: 14 }} />
                    </div>
                    <p className="text-secondary-light text-xs mb-0">Monthly MRR lost from churned &amp; cancelled accounts</p>
                  </div>
                  <div className="d-flex align-items-center gap-12">
                    {[{ label: "MRR Lost", color: "#ef4444" }, { label: "Cumulative", color: "#f97316" }].map((l) => (
                      <span key={l.label} className="d-flex align-items-center gap-6 text-xs text-secondary-light">
                        <span style={{ width: 20, height: 2, background: l.color, display: "inline-block", borderRadius: 2 }} />
                        {l.label}
                      </span>
                    ))}
                  </div>
                </div>
                <div className="card-body p-16">
                  <ReactApexChart
                    type="line"
                    height={240}
                    options={{
                      chart: { type: "line", toolbar: { show: false }, zoom: { enabled: false } },
                      stroke: { curve: "smooth", width: [2, 2], dashArray: [0, 4] },
                      colors: ["#ef4444", "#f97316"],
                      xaxis: {
                        categories: ["Nov", "Dec", "Jan", "Feb", "Mar", "Apr"],
                        labels: { style: { fontSize: "11px" } },
                        axisBorder: { show: false }, axisTicks: { show: false },
                      },
                      yaxis: { labels: { formatter: (v) => `$${v}`, style: { fontSize: "11px" } } },
                      grid: { borderColor: "#f3f4f6", strokeDashArray: 4 },
                      tooltip: { y: { formatter: (v) => `$${v.toLocaleString()}` } },
                      markers: { size: 4, strokeWidth: 0 },
                      legend: { show: false },
                    }}
                    series={[
                      { name: "MRR Lost",    data: [480, 310, 920, 560, 740, 1230] },
                      { name: "Cumulative",  data: [480, 790, 1710, 2270, 3010, 4240] },
                    ]}
                  />
                </div>
              </div>
            </div>

            {/* Chart 2 — Cancellations by Plan */}
            <div className="col-xl-4">
              <div className="card h-100">
                <div className="card-header border-bottom bg-base py-16 px-24">
                  <div className="d-flex align-items-center gap-8 mb-4">
                    <h6 className="fw-semibold mb-0">Cancellations by Plan</h6>
                    <Icon icon="solar:info-circle-outline" className="text-secondary-light" style={{ fontSize: 14 }} />
                  </div>
                  <p className="text-secondary-light text-xs mb-0">Which plans lost the most accounts</p>
                </div>
                <div className="card-body p-16">
                  <ReactApexChart
                    type="donut"
                    height={200}
                    options={{
                      labels: ["Single Site", "Unlimited", "Trial 30", "Trial 7", "No Plan"],
                      colors: ["#3b82f6", "#8b5cf6", "#f59e0b", "#22c55e", "#ef4444"],
                      legend: { position: "bottom", fontSize: "12px" },
                      dataLabels: { enabled: true, formatter: (v) => `${Math.round(v)}%` },
                      plotOptions: { pie: { donut: { size: "60%" } } },
                      tooltip: { y: { formatter: (v) => `${v} accounts` } },
                    }}
                    series={[4, 2, 1, 1, 0]}
                  />
                </div>
              </div>
            </div>

          </div>

          {/* Chart 3 — Account Lifespan Before Cancellation */}
          <div className="card mb-24">
            <div className="card-header border-bottom bg-base py-16 px-24 d-flex align-items-center justify-content-between">
              <div>
                <div className="d-flex align-items-center gap-8 mb-4">
                  <h6 className="fw-semibold mb-0">Account Lifespan Before Cancellation</h6>
                  <Icon icon="solar:info-circle-outline" className="text-secondary-light" style={{ fontSize: 14 }} />
                </div>
                <p className="text-secondary-light text-xs mb-0">How long accounts stayed active before churning</p>
              </div>
              <div className="d-flex align-items-center gap-12">
                {[{ label: "Accounts", color: "#ef4444" }, { label: "MRR Lost", color: "#f97316" }].map((l) => (
                  <span key={l.label} className="d-flex align-items-center gap-6 text-xs text-secondary-light">
                    <span style={{ width: 10, height: 10, borderRadius: "50%", background: l.color, display: "inline-block" }} />
                    {l.label}
                  </span>
                ))}
              </div>
            </div>
            <div className="card-body p-16">
              <ReactApexChart
                type="bar"
                height={220}
                options={{
                  chart: { type: "bar", toolbar: { show: false }, zoom: { enabled: false } },
                  plotOptions: { bar: { borderRadius: 4, columnWidth: "50%", dataLabels: { position: "top" } } },
                  colors: ["#ef4444", "#f97316"],
                  xaxis: {
                    categories: ["< 7 days", "7–30 days", "1–3 months", "3–6 months", "6–12 months", "> 1 year"],
                    labels: { style: { fontSize: "11px" } },
                    axisBorder: { show: false }, axisTicks: { show: false },
                  },
                  yaxis: [
                    { title: { text: "Accounts", style: { fontSize: "11px" } }, labels: { style: { fontSize: "11px" } } },
                    { opposite: true, title: { text: "MRR Lost ($)", style: { fontSize: "11px" } }, labels: { formatter: (v) => `$${v}`, style: { fontSize: "11px" } } },
                  ],
                  grid: { borderColor: "#f3f4f6", strokeDashArray: 4 },
                  tooltip: {
                    shared: true,
                    intersect: false,
                    y: [{ formatter: (v) => `${v} accounts` }, { formatter: (v) => `$${v.toLocaleString()}` }],
                  },
                  legend: { show: false },
                  dataLabels: { enabled: false },
                }}
                series={[
                  { name: "Accounts",  data: [1, 2, 3, 1, 1, 0] },
                  { name: "MRR Lost",  data: [99, 198, 897, 299, 299, 0], yAxisIndex: 1 },
                ]}
              />
            </div>
          </div>

          {/* Table */}
          <div className="card" style={{ overflow: "hidden" }}>
            <div className="card-header border-bottom bg-base py-16 px-24 d-flex align-items-center justify-content-between flex-wrap gap-12">
              <div>
                <h6 className="fw-semibold mb-2">Churned &amp; Cancelled Accounts</h6>
                <p className="text-secondary-light text-xs mb-0">Accounts that cancelled, churned, or downgraded this period</p>
              </div>
              <button className="btn btn-sm radius-8 px-14 py-6 d-flex align-items-center gap-6"
                style={{ border: "1px solid var(--border-color)", background: "#fff", fontSize: 13 }}>
                <Icon icon="solar:export-outline" style={{ fontSize: 14 }} /> Export Churn Report
              </button>
            </div>
            <div style={{ overflowX: "auto" }}>
              <table style={{ width: "100%", borderCollapse: "collapse", minWidth: 780 }}>
                <thead>
                  <tr style={{ background: "#fafafa", borderBottom: "1px solid var(--border-color)" }}>
                    <th style={{ width: 36, padding: "10px 16px" }}>
                      <input type="checkbox" style={{ accentColor: "var(--primary-600)" }} />
                    </th>
                    {[
                      { label: "Account",      sort: true  },
                      { label: "Plan",         sort: true  },
                      { label: "Churned Date", sort: true  },
                      { label: "MRR Lost",     sort: true,  info: true },
                      { label: "Reason",       sort: false, filter: true },
                      { label: "Status",       sort: false, filter: true },
                    ].map((col, ci) => (
                      <th key={ci} style={{ padding: "10px 12px", fontSize: 11, fontWeight: 600, color: "#6b7280", textTransform: "uppercase", letterSpacing: "0.04em", whiteSpace: "nowrap" }}>
                        <span className="d-inline-flex align-items-center gap-4">
                          {col.label}
                          {col.sort   && <Icon icon="solar:sort-vertical-outline" style={{ fontSize: 11, opacity: 0.4 }} />}
                          {col.info   && <Icon icon="solar:info-circle-outline"   style={{ fontSize: 11, opacity: 0.4 }} />}
                          {col.filter && <Icon icon="solar:filter-outline"        style={{ fontSize: 11, opacity: 0.4 }} />}
                        </span>
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {data.lostRevenue.items.map((row, i) => {
                    const statusStyle = row.status === "Cancelled"
                      ? { background: "#fef2f2", color: "#dc2626", border: "1px solid #fecaca" }
                      : row.status === "Suspended"
                      ? { background: "#fff7ed", color: "#ea580c", border: "1px solid #fed7aa" }
                      : { background: "#f0fdf4", color: "#16a34a", border: "1px solid #bbf7d0" };
                    return (
                      <tr key={i}
                        style={{ borderBottom: "1px solid var(--border-color)", borderLeft: "3px solid #ef4444", transition: "background 0.12s" }}
                        onMouseEnter={(e) => e.currentTarget.style.background = "#fff8f8"}
                        onMouseLeave={(e) => e.currentTarget.style.background = "transparent"}
                      >
                        <td style={{ padding: "12px 16px" }}>
                          <input type="checkbox" style={{ accentColor: "var(--primary-600)" }} />
                        </td>
                        <td style={{ padding: "12px 12px", minWidth: 160 }}>
                          <div className="d-flex align-items-center gap-10">
                            <div className="d-flex align-items-center justify-content-center rounded-circle fw-bold flex-shrink-0"
                              style={{ width: 32, height: 32, background: row.color + "22", color: row.color, fontSize: 12 }}>
                              {row.initials}
                            </div>
                            <span style={{ fontSize: 13, fontWeight: 500, color: "var(--primary-600)", cursor: "pointer" }}>{row.name}</span>
                          </div>
                        </td>
                        <td style={{ padding: "12px 12px", fontSize: 13, color: "#6b7280", maxWidth: 200 }}>{row.plan}</td>
                        <td style={{ padding: "12px 12px", fontSize: 13, color: "#6b7280", whiteSpace: "nowrap" }}>{row.churnedDate}</td>
                        <td style={{ padding: "12px 12px", whiteSpace: "nowrap" }}>
                          <span style={{ fontSize: 13, fontWeight: 700, color: "#dc2626" }}>${row.mrrLost.toLocaleString()}</span>
                        </td>
                        <td style={{ padding: "12px 12px" }}>
                          <span style={{ fontSize: 11, fontWeight: 600, padding: "3px 10px", borderRadius: 6, background: "#f3f4f6", color: "#374151" }}>
                            {row.reason}
                          </span>
                        </td>
                        <td style={{ padding: "12px 12px" }}>
                          <span style={{ fontSize: 11, fontWeight: 600, padding: "3px 10px", borderRadius: 6, whiteSpace: "nowrap", ...statusStyle }}>
                            {row.status}
                          </span>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
            <div className="d-flex align-items-center justify-content-between px-16 py-12" style={{ borderTop: "1px solid var(--border-color)" }}>
              <span style={{ fontSize: 13, color: "#6b7280" }}>
                Showing {data.lostRevenue.items.length} of {data.lostRevenue.churnedAccounts} accounts
              </span>
              <div className="d-flex align-items-center gap-8">
                <button className="btn btn-sm radius-6 px-10 py-4" style={{ border: "1px solid var(--border-color)", fontSize: 13 }} disabled>
                  <Icon icon="solar:alt-arrow-left-outline" /> Previous
                </button>
                <span className="d-flex align-items-center justify-content-center radius-6 fw-semibold"
                  style={{ width: 32, height: 32, background: "var(--primary-600)", color: "#fff", fontSize: 13 }}>1</span>
                <span style={{ fontSize: 13, color: "#6b7280" }}>/ 1</span>
                <button className="btn btn-sm radius-6 px-10 py-4" style={{ border: "1px solid var(--border-color)", fontSize: 13 }} disabled>
                  Next <Icon icon="solar:alt-arrow-right-outline" />
                </button>
              </div>
            </div>
          </div>
        </>
      )}

    </div>
  );
};

export default RevenueAnalytics;
